// Main entry point for the Challenge System library

// Import all modules
import { ChallengeValidation } from './validation';
import { ChallengeCalculations } from './calculations';
import { ChallengeAPI, ChallengeHelpers } from './api';

// Core functionality - re-export classes
export { ChallengeValidation } from './validation';
export { ChallengeCalculations } from './calculations';
export { ChallengeAPI, ChallengeHelpers } from './api';

// Re-export types for convenience
export type {
  ChallengeTemplate,
  ActiveChallenge,
  ChallengeHistoryItem,
  ChallengeProgress,
  StreakData,
  StreakMilestone,
  StartChallengeRequest,
  StartChallengeResponse,
  UpdateChallengeProgressRequest,
  UpdateChallengeProgressResponse,
  GetActiveChallengesResponse,
  GetAvailableChallengesResponse,
  GetChallengeHistoryResponse,
  ChallengeStats,
  ChallengeValidationResult,
  ChallengeDifficulty,
  StreakType
} from '../../types/challenge';

export {
  DEFAULT_CHALLENGE_TEMPLATES,
  CHALLENGE_CONSTANTS
} from '../../types/challenge';

// Helper function to initialize the challenge system
export const initializeChallengeSystem = () => {
  // Any initialization logic can go here
  console.log('Challenge System initialized');
};

// Export commonly used functions from ChallengeHelpers
export const sortChallengesByPriority = ChallengeHelpers.sortChallengesByPriority;
export const filterChallengesByStatus = ChallengeHelpers.filterChallengesByStatus;
export const groupChallengesByDifficulty = ChallengeHelpers.groupChallengesByDifficulty;
export const calculateCompletionRate = ChallengeHelpers.calculateCompletionRate;
export const calculateChallengeStats = ChallengeHelpers.calculateChallengeStats;
export const formatTimeRemaining = ChallengeHelpers.formatTimeRemaining;
export const getProgressColor = ChallengeHelpers.getProgressColor;
export const getDifficultyVariant = ChallengeHelpers.getDifficultyVariant;
export const formatProgressText = ChallengeHelpers.formatProgressText;

// Export commonly used functions from ChallengeAPI
export const getActiveChallenges = ChallengeAPI.getActiveChallenges;
export const getAvailableChallenges = ChallengeAPI.getAvailableChallenges;
export const startChallenge = ChallengeAPI.startChallenge;
export const updateChallengeProgress = ChallengeAPI.updateChallengeProgress;
export const getChallengeHistory = ChallengeAPI.getChallengeHistory;
export const updateMultipleChallengeProgress = ChallengeAPI.updateMultipleChallengeProgress;

// Export commonly used functions from ChallengeCalculations
export const calculateChallengeProgress = ChallengeCalculations.calculateChallengeProgress;
export const calculatePointsEarned = ChallengeCalculations.calculatePointsEarned;
export const calculateStreakData = ChallengeCalculations.calculateStreakData;
export const updateChallengeStatus = ChallengeCalculations.updateChallengeStatus;
export const getChallengeCompletionMessage = ChallengeCalculations.getChallengeCompletionMessage;

// Export commonly used functions from ChallengeValidation
export const validateTemplate = ChallengeValidation.validateTemplate;
export const validateStartChallengeRequest = ChallengeValidation.validateStartChallengeRequest;
export const validateProgressUpdate = ChallengeValidation.validateProgressUpdate;
export const canCompleteChallenge = ChallengeValidation.canCompleteChallenge;
export const isChallengeExpired = ChallengeValidation.isChallengeExpired;
export const getTemplateById = ChallengeValidation.getTemplateById;
export const isOnTrack = ChallengeValidation.isOnTrack;
export const getDaysRemaining = ChallengeValidation.getDaysRemaining;
export const validatePointsCalculation = ChallengeValidation.validatePointsCalculation;
export const hasConflictingChallenges = ChallengeValidation.hasConflictingChallenges;